import React from "react";
import "./Ordinateur.css";
import PC_FIXE from "./Pc_Fixe.png";
import Pc_PORTABLE from "./Pc_Portable.png";
import NAS from "./NAS.png";
import PresMedical from './PresMedical.png';
import SEO from "../../Hook/Seo";
import BreadcrumbsSchema from "../../Hook/BreadcrumbsSchema";
import Serveur from "./Serveur.png";
import { useNavigate } from "react-router-dom";
import VideoPresentationInformatique from '../../pages/Informatique/video_presentation_informatique.mp4'

const Ordinateur = ({ openTarifs }) => {
    const navigate = useNavigate();

    return (
        <>
            <SEO
                title="Matériel Informatique & Vente Professionnelle dans les Vosges | AM Services"
                description="Découvrez notre sélection de parcs informatiques, serveurs d'entreprises, NAS et périphériques médicaux durables."
                path="/ordinateur"
            />
            <BreadcrumbsSchema />

            <div className="div_container">
                <video
                    src={VideoPresentationInformatique}
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="background-video"
                    aria-label="Vidéo de présentation du matériel informatique"
                />
                <div className="hero-overlay"></div>
                <div className="info-hero-center-text">
                    <h1 className="info-title">MATÉRIEL ET VENTES</h1>
                    <p className="info-lead">
                        Chez AM Services, nous vous proposons une sélection de matériel informatique de pointe en partenariat avec les plus grandes marques.

                    </p>
                </div>
                
            </div>

            <h2 className="section-title">Matériel et Vente</h2>

            <section className={`flex-grid ${openTarifs ? "with-sidebar" : ""}`}>
                <article className="card">
                    <h4 className="card-title">Ordinateur Fixe</h4>
                    <img className="card-img" src={PC_FIXE} alt="Gamme PC Fixe" onClick={() => navigate("/pc-fixe")} />
                    <p className="text-default"> Puissance, évolutivité et durabilité réunies pour accompagner la productivité de vos équipes au bureau. </p>
                    <button className="btn-primary" onClick={() => navigate("/pc-fixe")}>EN SAVOIR PLUS</button>
                </article>

                <article className="card">
                    <h4 className="card-title">Ordinateur Portable</h4>
                    <img className="card-img" src={Pc_PORTABLE} alt="Gamme PC Portable" onClick={() => navigate("/pc-portable")} />
                    <p className="text-default"> Mobilité et performances sans compromis pour vous accompagner partout en déplacement ou télétravail. </p>
                    <button className="btn-primary" onClick={() => navigate("/pc-portable")}>EN SAVOIR PLUS</button>
                </article>

                <article className="card">
                    <h4 className="card-title">Serveur NAS</h4>
                    <img className="card-img" src={NAS} alt="Solutions de stockage NAS" onClick={() => navigate("/nas")} />
                    <p className="text-default"> Sécurisez et centralisez vos fichiers d'entreprise avec un espace de stockage réseau partagé toujours disponible. </p>
                    <button className="btn-primary" onClick={() => navigate("/nas")}>EN SAVOIR PLUS</button>
                </article>

                <article className="card">
                    <h4 className="card-title">Serveur</h4>
                    <img className="card-img" src={Serveur} alt="Gamme serveurs d'entreprise" onClick={() => navigate("/serveur")} />
                    <p className="text-default"> Optez pour la haute disponibilité avec nos architectures serveurs sur mesure adaptées à vos bases de données. </p>
                    <button className="btn-primary" onClick={() => navigate("/serveur")}>EN SAVOIR PLUS</button>
                </article>

                <article className="card">
                    <h4 className="card-title">Médical</h4>
                    <img className="card-img" src={PresMedical} alt="Équipements informatiques médicaux" onClick={() => navigate("/medical")} />
                    <p className="text-default"> Matériel informatique et périphériques hygiéniques lavables conformes aux normes du secteur de la santé. </p>
                    <button className="btn-primary" onClick={() => navigate("/medical")}>EN SAVOIR PLUS</button>
                </article>
            </section>
        </>
    );
};

export default Ordinateur;